import type { QueryClient } from '@tanstack/react-query';
import { refreshQueries } from '../refresh';
import { REQUESTS_KEY } from '../requests/types';
import { CREW_KEY } from './types';

/**
 * After ANY crew change — a person added, removed, changed, a status, a place filled, freed, added or removed, „Wymuś”,
 * a mark that withdrew someone (owner 2026-10-26 07:42 „to musi się synchronizować”). Everything that shows the crew
 * lives under `CREW_KEY`: the event's Obsada and places, the grid „Dostępność → Ludzie” (`PEOPLE_GRID_KEY`), its
 * events strip, side panel and person panel of „Obsadź…” (`OPEN_KEY`), „Mój kalendarz”. Reads in flight are restarted (`refreshQueries`), so
 * a read that began before the change was saved cannot put the old state back; screens not shown read again when shown.
 * Review I4 (owner 2026-10-30 01:30): also the questions and answers (`REQUESTS_KEY`: „Zapytania i odpowiedzi”, the badges
 * of Obsada and the side panel) — a mark or a status changes the answer as it stands.
 */
export const refreshCrew = async (queryClient: QueryClient): Promise<void> => {
  await Promise.all([refreshQueries(queryClient, CREW_KEY), refreshQueries(queryClient, REQUESTS_KEY)]);
};
